<template>
    <HjTextField
      v-bind="{...$attrs, ...$props}"
      v-on="$listeners"
      v-model="displayValue"
      maxlength="14"
      prepend-inner-icon="mdi-phone"
      phone
    >
</HjTextField>
  </template>
  
  <script>
import HjTextField from './HjTextField.vue';

  export default {
    name: "HjPhoneField",
  
    props : {
      value : {
        required : false,
        type : String,
        default : '',
      },
    },
  
    components : {
      HjTextField
    },
  
    data() {
      return {
        phoneNumber: ''
      }
    },
  
    computed : {
      displayValue: {
        get() {
          return this.value ? this.formatPhone(this.value) : this.formattedPhoneNumber
        },
        set(newValue) {
          this.phoneNumber = newValue.replace(/\D/g, '')
        }
      },
  
      formattedPhoneNumber: {
      get() {
        return this.formatPhone(this.phoneNumber)
      },
      set(newValue) {
        this.phoneNumber = newValue.replace(/\D/g, '')
      }
    },
      phoneRules(){
        let rules = [
          v => !!v || 'Phone Number is required',
          v => (v => (v && v.replace(/\D/g, '').length === 10) || 'Phone Number must be 10 digits'),
        ]
  
        if ( this.required ){
          rules.push(v => (!!v && !Array.isArray(v)) || v === 0 || (Array.isArray(v) && v.length > 0) || 'Field is required')
        }
  
        return rules
      }
    },
  
    methods: {
      formatPhone(str) {
    str = str.replace(/\D/g, '');
    if (str.length === 0) return '';
    if (str.length <= 3) return `(${str})`;
    if (str.length <= 6) return `(${str.substring(0, 3)}) ${str.substring(3, 6)}`;
    if (str.length <= 10) return `(${str.substring(0, 3)}) ${str.substring(3, 6)}-${str.substring(6, 10)}`;
    return str;
  }
  }
  
  }
  </script>
  
  <style scoped>
  
  </style>